"use client";
import { useState } from "react";
import { twMerge } from "tailwind-merge";

export interface Props {
  text: string;
  maxLength: number;
  className?: string;
}

const ExpandableText = ({ text, maxLength, className }: Props) => {
  const [expanded, setExpanded] = useState(false);

  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  return (
    <>
      {text && (
        <div
          className={twMerge(
            "flex flex-col gap-y-4 font-light mx-0 lg:mx-28 text-center mt-7 lg:mt-10",
            className,
          )}
        >
          {expanded ? text : text.slice(0, maxLength)}
          {text.length > maxLength && (
            <span
              className="text-red cursor-pointer block"
              onClick={toggleExpanded}
            >
              {expanded ? "...Show less" : "Read more..."}
            </span>
          )}
        </div>
      )}
    </>
  );
};

export default ExpandableText;
